export const getCustomerLoyaltyAccess = (productData, isMixAndMatch) => {
  const product = isMixAndMatch
    ? productData?.products?.find((product) => product.earlyAccess)
    : productData;

  return {
    customerAccess: product?.earlyAccess?.customerAccess ?? null,
    endDate: product?.earlyAccess?.endDate ?? null,
  };
};
